import styled from 'styled-components';
import { breakPoint } from '@ertelecom/ui-react/assets/js/constants';
import ChannelTooltip from '../tooltip';

export const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: -20px;

    @media (max-width: 1280px) {
        margin-bottom: -12px;
    }
`;

export const Channel = styled(ChannelTooltip)`
    width: 50%;
    padding-right: 10px;
    margin-right: 0;
    margin-bottom: 20px;

    @media(${breakPoint(320)}) {
        width: 100%;
    }

    @media (max-width: 1280px) {
        display: flex;
        margin-bottom: 12px;
    }
`;
